import {Injectable, signal} from '@angular/core';

export interface ProductHeaderParams {
  code: string;
  colour: string;
  title: string;
}

@Injectable({
  providedIn: 'root',
})
export class HeaderParamsService {
  // Array of product header parameters
  // ⚠️ If you change colours here, also update the inline script in index.html
  private productHeaderParams: ProductHeaderParams[] = [
    { code: 'default', colour: '#8B1F43', title: 'RevisionHub' },
    { code: '11-plus-online-tests', colour: '#0075BF', title: '' },
    { code: 'acehr43', colour: '#E65306', title: 'GCSE English Edexcel Poetry Guide — Conflict' },
    { code: 'achr45', colour: '#E65306', title: 'GCSE English AQA Poetry Guide — Power & Conflict' },
    { code: 'alhr42', colour: '#007078', title: 'GCSE English AQA Poetry Guide — Worlds & Lives' },
    { code: 'arehr43', colour: '#288B31', title: 'GCSE English Edexcel Poetry Guide — Relationships' },
    { code: 'arhr45', colour: '#8B1F43', title: 'GCSE English AQA Poetry Guide — Love & Relationships' },
    { code: 'awhr43', colour: '#C0032E', title: 'GCSE WJEC English Literature — Poetry Anthology' },
    { code: 'bafq43', colour: '#288B31', title: 'GCSE AQA Biology RevisionHub' },
    { code: 'bafr43', colour: '#288B31', title: 'GCSE AQA Biology RevisionHub' },
    { code: 'baq43', colour: '#288B31', title: 'GCSE AQA Biology Exam Practice Workbook' },
    { code: 'baq72', colour: '#288B31', title: 'A-Level AQA Biology Exam Practice Workbook' },
    { code: 'bar47', colour: '#288B31', title: 'GCSE AQA Biology RevisionHub' },
    { code: 'bar74', colour: '#288B31', title: 'AQA A-Level Biology Complete Revision and Practice' },
    { code: 'bas47', colour: '#288B31', title: 'GCSE AQA Biology RevisionHub' },
    { code: 'cafq43', colour: '#E65306', title: 'GCSE AQA Chemistry Exam Practice Workbook' },
    { code: 'cafr43', colour: '#E65306', title: 'GCSE AQA Chemistry RevisionHub' },
    { code: 'caq43', colour: '#E65306', title: 'GCSE AQA Chemistry Exam Practice Workbook' },
    { code: 'caq72', colour: '#E65306', title: 'A-Level AQA Chemistry Exam Practice Workbook' },
    { code: 'car47', colour: '#E65306', title: 'GCSE AQA Chemistry RevisionHub' },
    { code: 'car74', colour: '#E65306', title: 'AQA A-Level Chemistry Complete Revision and Practice' },
    { code: 'cas47', colour: '#E65306', title: 'GCSE AQA Chemistry RevisionHub' },
    { code: 'daq42', colour: '#012169', title: 'GCSE AQA German Exam Practice Workbook' },
    { code: 'dar42', colour: '#012169', title: 'GCSE AQA German Revision Guide' },
    { code: 'das43', colour: '#012169', title: 'GCSE AQA German Complete Revision & Practice' },
    { code: 'eahs44', colour: '#6E38AB', title: 'GCSE AQA English Language & Literature' },
    { code: 'enar43', colour: '#6E38AB', title: 'GCSE AQA English Language Revision Guide' },
    { code: 'enas44', colour: '#6E38AB', title: 'GCSE AQA English Language Complete Revision & Practice', },
    { code: 'eta45', colour: '#353535', title: 'GCSE English Text Guide — Animal Farm' },
    { code: 'etbb43', colour: '#353535', title: 'GCSE English Text Guide — Blood Brothers' },
    { code: 'etcc43', colour: '#353535', title: 'GCSE English Text Guide — A Christmas Carol' },
    { code: 'etf43', colour: '#353535', title: 'GCSE English Text Guide — Frankenstein' },
    { code: 'etg45', colour: '#353535', title: 'GCSE English Text Guide — Great Expectations' },
    { code: 'eti46', colour: '#353535', title: 'GCSE English Text Guide — An Inspector Calls' },
    { code: 'etje43', colour: '#353535', title: 'GCSE English Text Guide — Jane Eyre' },
    { code: 'etjh43', colour: '#353535', title: 'GCSE English Text Guide — Dr Jekyll and Mr Hyde' },
    { code: 'etl46', colour: '#353535', title: 'GCSE English Text Guide — Lord of the Flies' },
    { code: 'etm45', colour: '#353535', title: 'GCSE English Text Guide — Macbeth' },
    { code: 'etma43', colour: '#353535', title: 'GCSE English Text Guide — Much Ado About Nothing' },
    { code: 'etmv43', colour: '#353535', title: 'GCSE English Text Guide — The Merchant of Venice' },
    { code: 'etp46', colour: '#353535', title: 'GCSE English Text Guide — Pride and Prejudice' },
    { code: 'etr46', colour: '#353535', title: 'GCSE English Text Guide — Romeo & Juliet' },
    { code: 'etsf43', colour: '#353535', title: 'GCSE English Text Guide — The Sign of the Four' },
    { code: 'faq42', colour: '#00823E', title: 'GCSE AQA French Exam Practice Workbook' },
    { code: 'far45', colour: '#00983D', title: 'GCSE AQA French Revision Guide' },
    { code: 'fas44', colour: '#00983D', title: 'GCSE AQA French Complete Revision & Practice' },
    { code: 'fas45', colour: '#8B1F43', title: 'GCSE AQA French Complete Revision & Practice' },
    { code: 'feq42', colour: '#00823E', title: 'GCSE Edexcel French Exam Practice Workbook' },
    { code: 'fer42', colour: '#00983D', title: 'GCSE Edexcel French Revision Guide' },
    { code: 'fes43', colour: '#00983D', title: 'GCSE Edexcel French Complete Revision & Practice' },
    { code: 'heano42', colour: '#353535', title: 'GCSE History — Anglo-Saxon and Norman England' },
    { code: 'heano43', colour: '#353535', title: 'GCSE History — Anglo-Saxon and Norman England ' },
    { code: 'heawo43', colour: '#353535', title: 'GCSE History — The American West' },
    { code: 'hecpo43', colour: '#353535', title: 'GCSE History — Crime and Punishment in Britain' },
    { code: 'hecwo43', colour: '#353535', title: 'GCSE History — Superpower Relations and the Cold War' },
    { code: 'heeao43', colour: '#353535', title: 'GCSE History — Early Elizabethan England' },
    { code: 'hembo43', colour: '#353535', title: 'GCSE History — Medicine in Britain' },
    { code: 'hewno43', colour: '#353535', title: 'GCSE History — Weimar and Nazi Germany' },
    { code: 'mcfq44', colour: '#006341', title: 'GCSE OCR Maths Exam Practice Workbook' },
    { code: 'mcfr49', colour: '#6f2c3f', title: 'GCSE OCR Maths Revision Guide' },
    { code: 'mcfs42', colour: '#6f2c3f', title: 'GCSE OCR Maths Complete Revision & Practice' },
    { code: 'mchq44', colour: '#6f2c3f', title: 'GCSE OCR Maths Exam Practice Workbook' },
    { code: 'mchr48', colour: '#6f2c3f', title: 'GCSE OCR Maths Revision Guide' },
    { code: 'mchs42', colour: '#6f2c3f', title: 'GCSE OCR Maths Complete Revision & Practice' },
    { code: 'mfq48', colour: '#006341', title: 'GCSE Maths Exam Practice Workbook' },
    { code: 'mfr141', colour: '#6f2c3f', title: 'GCSE Maths Revision Guide' },
    { code: 'mfs49', colour: '#6f2c3f', title: 'GCSE Maths Complete Revision & Practice' },
    { code: 'mhq48', colour: '#6f2c3f', title: 'GCSE Maths Exam Practice Workbook' },
    { code: 'mhr141', colour: '#6f2c3f', title: 'GCSE Maths Revision Guide' },
    { code: 'mhs49', colour: '#6f2c3f', title: 'GCSE Maths Complete Revision & Practice' },
    { code: 'mwhr43', colour: '#8B1F43', title: 'GCSE WJEC Maths RevisionHub' },
    { code: 'mxfq44', colour: '#006341', title: 'GCSE Maths Exam Practice Workbook' },
    { code: 'mxhq44', colour: '#6f2c3f', title: 'GCSE Maths Exam Practice Workbook' },
    { code: 'pafq43', colour: '#60269E', title: 'GCSE AQA Physics Exam Practice Workbook' },
    { code: 'pafr43', colour: '#60269E', title: 'GCSE AQA Physics RevisionHub' },
    { code: 'paq43', colour: '#60269E', title: 'GCSE AQA Physics Exam Practice Workbook' },
    { code: 'paq72', colour: '#60269E', title: 'A-Level AQA Physics Exam Practice Workbook' },
    { code: 'par49', colour: '#60269E', title: 'GCSE AQA Physics RevisionHub' },
    { code: 'par74', colour: '#60269E', title: 'AQA A-Level Physics Complete Revision and Practice' },
    { code: 'pas49', colour: '#60269E', title: 'GCSE AQA Physics RevisionHub' },
    { code: 'safq43',colour: '#8A2432', title: 'GCSE AQA Combined Science Exam Practice Workbook', },
    { code: 'safr47', colour: '#D50200', title: 'GCSE Combined Science AQA RevisionHub' },
    { code: 'sahq43', colour: '#8A2432', title: 'GCSE AQA Combined Science Exam Practice Workbook', },
    { code: 'sahr47', colour: '#8A2432', title: 'GCSE Combined Science AQA RevisionHub' },
    { code: 'scafs43', colour: '#D50200', title: 'GCSE Combined Science AQA RevisionHub' },
    { code: 'scahs43', colour: '#8A2432', title: 'GCSE Combined Science AQA RevisionHub' },
    { code: 'spaq42', colour: '#AC145A', title: 'GCSE AQA Spanish Exam Practice Workbook' },
    { code: 'spar42', colour: '#AC145A', title: 'GCSE AQA Spanish Revision Guide' },
    { code: 'spas43', colour: '#AC145A', title: 'GCSE AQA Spanish Complete Revision & Practice' },
    { code: 'speq42', colour: '#AC145A', title: 'GCSE Edexcel Spanish Exam Practice Workbook' },
    { code: 'sper42', colour: '#AC145A', title: 'GCSE Edexcel Spanish Revision Guide' },
    { code: 'spes43', colour: '#AC145A', title: 'GCSE Edexcel Spanish Complete Revision & Practice',
    },
  ];

  // Reactive signals for header state
  readonly headerTitle = signal('RevisionHub');
  readonly headerColour = signal('#8B1F43');
  readonly footerColour = signal('#8B1F43');
  readonly isDefaultHeader = signal(true);
  readonly isElevenPlus = signal(false);
  readonly showProfileInfo = signal(false);

  // Helper to get params for a product code
  getHeaderParams(productCode: string): ProductHeaderParams {
    return (
      this.productHeaderParams.find((p) => p.code === productCode) ||
      this.productHeaderParams.find((p) => p.code === 'default')!
    );
  }

  getColourForProductCode(productCode: string): string {
    return this.getHeaderParams(productCode).colour;
  }

  getTitleForProductCode(productCode: string): string {
    return this.getHeaderParams(productCode).title;
  }

  setHeaderColour(colour: string): void {
    this.headerColour.set(colour);
  }

  setHeaderTextEndVisibility(productCode: string): void {
    const headerTextEnd = document.querySelector('.header-text-end');
    if (headerTextEnd) {
      if (productCode === 'default') {
        (headerTextEnd as HTMLElement).style.display = 'none';
      } else {
        // Clear inline style so CSS/media queries control display
        (headerTextEnd as HTMLElement).style.display = '';
      }
    }
  }

  setHeaderTextCenter(titleText: string): void {
    this.headerTitle.set(titleText);
  }

  setFooterColour(colour: string): void {
    this.footerColour.set(colour);
  }

  setShowProfileInfo(show: boolean): void {
    this.showProfileInfo.set(show);
  }

  // Method to change the header parameters based on the product code
  setHeaderInfo(productCode: string): void {
    const params = this.getHeaderParams(productCode);
    this.setShowProfileInfo(false);
    this.setHeaderColour(params.colour);
    this.setFooterColour(productCode === '11-plus-online-tests' ? '#0075BF' : '#8B1F43');
    this.isElevenPlus.set(productCode === '11-plus-online-tests');
    this.setHeaderTextEndVisibility(productCode);
    this.setHeaderTextCenter(params.title);
    this.isDefaultHeader.set(productCode === 'default' || productCode === '11-plus-online-tests');
  }
}
